import React from "react";
import { ArrowLeft, X } from "lucide-react";

export default function ProfilePageShell({
  title,
  subtitle,
  backTo,
  backLabel,
  backIcon = "arrow",
  onBack,
  actions,
  children,
  maxWidth = "max-w-4xl",
}) {
  const BackIcon = backIcon === "close" ? X : ArrowLeft;

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }
    // Default: return to the previous route when possible, else home.
    try {
      if (window.history?.length > 1) window.history.back();
      else window.location.assign("/");
    } catch {
      window.location.assign("/");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-950 mobile-nav-safe-padding">
      <div className="sticky top-0 z-30 bg-white dark:bg-neutral-900 border-b border-gray-200 dark:border-neutral-800">
        <div className={`${maxWidth} mx-auto px-3 sm:px-4 h-12 flex items-center justify-between gap-3`}>
          <div className="flex items-center gap-2 min-w-0">
            {(backTo || onBack) && (
              <button
                type="button"
                onClick={handleBack}
                className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-800 text-gray-600 dark:text-gray-300"
                aria-label={backLabel || "Back"}
                title={backLabel || "Back"}
              >
                <BackIcon className="w-4 h-4" />
              </button>
            )}
            <div className="min-w-0">
              <h1 className="text-base font-semibold text-gray-900 dark:text-white truncate">{title}</h1>
              {subtitle ? (
                <p className="hidden sm:block text-xs text-gray-500 dark:text-gray-400 truncate">{subtitle}</p>
              ) : null}
            </div>
          </div>
          {actions ? <div className="flex-shrink-0">{actions}</div> : null}
        </div>
      </div>

      <main className={`${maxWidth} mx-auto px-3 sm:px-4 py-3 sm:py-4`}>{children}</main>
    </div>
  );
}
